<template>
  <button
    @click.prevent="handleClick"
    class="toggle-button"
    :data-active="active"
    :disabled="disabled"
  >
    <slot v-if="!active"></slot>
    <CheckmarkSVG v-if="active" />
  </button>
</template>

<script>
import CheckmarkSVG from "@/assets/checkmark.svg";

export default {
  name: "ToggleButton",
  components: {
    CheckmarkSVG,
  },
  props: ["active", "disabled"],
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
}
</script>

<style lang="scss" scoped>
  $border-width: 2px;
  $width: 50px + $border-width;
  $padding: 12px;

  .toggle-button {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    height: $width;
    width: $width;
    padding: $padding;
    margin: 0;
    text-align: center;
    border-radius: $width;
    border: solid 2px fade-out($color: $color-white, $amount: 1);
    cursor: pointer;
    background-color: $color-grey;
    transition: none;

    &:hover, &[data-active=true] {
      border-color: $color-white;
      color: $color-white;
      background-color: $color-blue;

      &::v-deep svg, * {
        color: $color-white;
        fill: $color-white;
      }

    }

    &::v-deep svg, * {
      width: 100%;
      max-height: 100%;
      transition: none;
    }

  }
</style>
